import {
  changeCardDataHash,
  deleteCardDataFromHash,
} from '@project/routes/utils';
import { IReactionDisposer, reaction } from 'mobx';
import { Card } from './Card';

export class CardToBrowserHistoryLink {
  private _disposer?: IReactionDisposer;

  constructor(private _card: Card) {}

  /** Создает подписку. Переключение между карточками добавляет новую запись в историю браузера */
  bind = () => {
    this.unbind();

    this._disposer = reaction(
      () => this._card.data,
      (data) => {
        const hash = window.location.hash;

        if (data) {
          const { tableName, recordId, layerName } = data;
          const url = changeCardDataHash(hash, tableName, recordId, layerName);

          history.pushState(null, '', `${url}`);
        } else {
          const url = deleteCardDataFromHash(hash);
          history.pushState(null, '', `${url}`);
        }
      },
    );

    return this.unbind;
  };

  unbind = () => {
    this._disposer?.();
    this._disposer = undefined;
  };
}
